import { outputSchemaPropTypes, signalPropTypes } from 'common/propTypes';
import  { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import ConditionalOperator from './ConditionalOperator/index';
import LeftOperand from './LeftOperand/index';
import Operator from './Operator/index';
import RightOperand from './RightOperand/index';

const propTypes = {
  signal: signalPropTypes.isRequired,
  shouldShowConditionalOperator: PropTypes.bool.isRequired,
  onUpdateSignal: PropTypes.func.isRequired,
  outputSchema: outputSchemaPropTypes.isRequired,
  signalType: PropTypes.string.isRequired,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  onDeleteSignal: PropTypes.func.isRequired,
  isShowDeleteBtn: PropTypes.bool.isRequired,
  caseIndex: PropTypes.number
};

const defaultProps = {
  caseIndex: undefined
};

const Signal = ({
  signal,
  shouldShowConditionalOperator,
  onUpdateSignal,
  outputSchema,
  signalType,
  control,
  errors,
  onDeleteSignal,
  isShowDeleteBtn,
  caseIndex
}) => {
  const {
    leftOperand, operator, rightOperand, conditionOperator
  } = signal;

  const onUpdateConditionalOperator = useCallback((newOperator) => {
    onUpdateSignal({ ...signal, conditionOperator: newOperator });
  }, [signal, onUpdateSignal]);

  const onChangeLeftOperand = useCallback((newLeftOperand) => {
    onUpdateSignal({
      ...signal, leftOperand: newLeftOperand, operator: '', rightOperand: ''
    });
  }, [signal, onUpdateSignal]);

  const trackAndUpdate = useCallback((label, value, callbackFn) => {
    if (window.trackEvent) {
      window.trackEvent(signalType, value, label);
    }
    callbackFn(value);
  }, [signalType]);

  return (
    <div className="signal-item rbt-main-form">
      {shouldShowConditionalOperator && (
        <ConditionalOperator
          conditionOperator={conditionOperator}
          onUpdateConditionalOperator={onUpdateConditionalOperator}
        />
      )}
      <div className="operand-info-wrap">
        <LeftOperand
          leftOperand={leftOperand}
          signalType={signalType}
          outputSchema={outputSchema}
          onChangeLeftOperand={(newLeftOperand) => {
            trackAndUpdate('leftOperand', newLeftOperand, onChangeLeftOperand);
          }}
          control={control}
          errors={errors}
          caseIndex={caseIndex}
        />
        <Operator
          operator={operator}
          leftOperand={leftOperand}
          outputSchema={outputSchema}
          onChangeOperator={(newOperator) => {
            trackAndUpdate('operator', newOperator, (updatedValue) => {
              onUpdateSignal({ ...signal, operator: updatedValue });
            });
          }}
          control={control}
          errors={errors}
        />
        <RightOperand
          rightOperand={rightOperand}
          outputSchema={outputSchema}
          leftOperand={leftOperand}
          signalType={signalType}
          control={control}
          errors={errors}
          onChangeRightOperand={(newRightOperand) => {
            trackAndUpdate('rightOperand', newRightOperand, (updatedValue) => {
              onUpdateSignal({ ...signal, rightOperand: updatedValue });
            });
          }}
          caseIndex={caseIndex}
        />
        {isShowDeleteBtn &&
          <button
            type="button"
            className="btn btn-outline-secondary me-2"
            onClick={onDeleteSignal}>
           <i className="fa-regular fa-trash-can tx-13"></i>
          </button>}
      </div>
    </div>
  );
};

Signal.propTypes = propTypes;
Signal.defaultProps = defaultProps;

export default memo(Signal);
